import { deviceStatsSelector } from "fleet/redux-store/ui-state/device-stats";
import {
  LOAD_DEVICE_STATS,
  unloadDeviceStatsAction,
} from "fleet/redux-store/ui-state/device-stats/actions";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { FetchController } from "ui/fetch/fetch-controller";

function mapStateToProps(state, props) {
  const objectLoaded = !isEmpty(deviceStatsSelector(state));

  return {
    objectLoaded,
    injectAs: "statsState",
    object: deviceStatsSelector(state),
    objectId: props.deviceId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchObject: (deviceId, _params, _options) => {
      return createPromiseApiAction(dispatch, LOAD_DEVICE_STATS, [deviceId]);
    },
    unloadObject: () => {
      return dispatch(unloadDeviceStatsAction);
    },
  };
}

const ConnectedFetchDeviceStatsController = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FetchController);

ConnectedFetchDeviceStatsController.propTypes = {
  deviceId: PropTypes.string.isRequired,
};

export { ConnectedFetchDeviceStatsController };
